import { render, staticRenderFns } from "./TheOrganizationAddressList.vue?vue&type=template&id=ae288e32&"
import script from "./TheOrganizationAddressList.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports